__turbopack_context__.v({
  "search_web_promoted_thumbnail": "pvwFIa_search_web_promoted_thumbnail",
  "search_web_promoted_thumbnail__compass_rose": "pvwFIa_search_web_promoted_thumbnail__compass_rose",
  "search_web_promoted_thumbnail__container": "pvwFIa_search_web_promoted_thumbnail__container",
  "search_web_promoted_thumbnail__description": "pvwFIa_search_web_promoted_thumbnail__description",
  "search_web_promoted_thumbnail__image": "pvwFIa_search_web_promoted_thumbnail__image",
  "search_web_promoted_thumbnail__link": "pvwFIa_search_web_promoted_thumbnail__link",
  "search_web_promoted_thumbnail__title": "pvwFIa_search_web_promoted_thumbnail__title",
});
